import {
  NBS_API_GET_MY_VIEWS_SUCCESS,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS,
  NBS_API_GET_MEMBER_PROFILE_SUCCESS
} from '../../constants/actions';
import { filterProfiles } from '../../assets/helpers/utils';
const initialState = {
  data: [],
  lastUserId: '',
  end: false
};

export default function reducer (state = initialState, action = {}) {
  const currentUsers = [...state.data];
  switch (action.type) {
    case NBS_API_GET_MY_VIEWS_SUCCESS:
      const currentState = {...state};
      const { users, end } = action.response;
      const lastUserId =
        end || !users || !users.length ? '' : users[users.length - 1].user_id;

      const newProfiles = filterProfiles(currentState.data, users);

      return {lastUserId, end, data: [...currentState.data, ...newProfiles]};
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const newUsers = currentUsers.filter(user => user.user_id !== action.userId);
      return {...state, data: newUsers};
    case NBS_API_GET_MEMBER_PROFILE_SUCCESS:
      const user = {...action.response};
      const idx = currentUsers.findIndex(u => u.user_id === user.user_id);

      if (idx === -1) {
        currentUsers.unshift(user);
      }

      return {...state, data: currentUsers};
    default:
      return state;
  }
}
